import { Html, Preload } from "@react-three/drei";
import { useDracoGLTF } from "../../utils/useDracoGLTF";
import { Ebbne, MountWithEbbne, MountWithLayer, useEbbnenContext } from "@solidwhite/ebbnen";
import HeatingScene, { Services, FactsNFigures } from "./HeatingScene";
import Section from "./Section";
import SubSection from "./SubSection";
import { ref } from "valtio";
import { useEffect } from "react";
import { cameraStore } from "../../appStore";
import OverviewSection from "./OverviewSection";
import { useRive } from "@rive-app/react-canvas";
import DissolvableMesh from "./DissolvableMesh";
import RoundedPodest from "./RoundedPodest";
import ChargeScene from "./charge/ChargeScene";
import { UIPortal } from "@solidwhite/ui-portal";
import Slogan from "../ui/Slogan";
import SideBar, { SideBarHider } from "../ui/SideBar/SideBar";
import MagneticFieldOverviewTile from "./heat/overview/MagneticFieldOverviewTile";
import { MountAutoplay } from "../MountAutoplay.tsx";
import EnvironmentRotationSetter from "./EnvironmentRotationSetter.tsx";

const Overview = ({ ...props }) => {
  const { nodes, scene } = useDracoGLTF("./models/overview.glb");

  return (
    <>
      <OverviewCam camSettings={nodes.CameraTarget} />

      <MountWithLayer layers={[0]}>
        <UIPortal>
          <Slogan key="L1_SLOGAN" />
        </UIPortal>
        <SideBarHider />

        <EnvironmentRotationSetter />

        {import.meta.env.MODE === "electron" && <MountAutoplay path={"guest/autoplay-all.json"} />}
      </MountWithLayer>

      <Ebbne id="heat" visibleWithAbove={1} visibleWithBelow={0}>
        <MountWithEbbne>
          <UIPortal>
            <Slogan key="L2_HEAT" textId="L2_HEAT" />
          </UIPortal>
          <SideBarHider />
        </MountWithEbbne>

        <MountWithEbbne mountedWhen="visible">
          <MagneticFieldOverviewTile node={nodes.heat} />
        </MountWithEbbne>

        <group>
          <OverviewSection object3d={nodes.heat} />
        </group>
        <HeatingScene />
      </Ebbne>

      <Ebbne id="charge" visibleWithAbove={1} visibleWithBelow={0}>
        <MountWithEbbne>
          <UIPortal>
            <Slogan key="L2_CHARGE" textId="L2_CHARGE" />
          </UIPortal>
          <SideBarHider />
        </MountWithEbbne>

        <group>
          <OverviewSection object3d={nodes.charge} />
        </group>
        <ChargeScene />
      </Ebbne>

      <Services nodes={nodes} />
      <FactsNFigures nodes={nodes} />
    </>
  );
};

const OverviewCam = ({ camSettings }) => {
  const { currentLayer } = useEbbnenContext();
  const active = currentLayer == 0;

  useEffect(() => {
    if (active) {
      cameraStore.cameraTargetSettings = ref(camSettings);
    }
  }, [active]);
  return null;
};

useDracoGLTF.preload("./models/overview.glb");

export default Overview;
